import { useAuthentication } from "../../auth/store/authSelectors";
import { getObservationService } from "../../services/observationService";
import * as Endpoint from "../../../endpoints";
import { IObservationPackage } from "../../interfaces/ObservationPackage/ObservationPackage";
import { makeFailure, makeSuccess, TResult, getSgApiService } from "../../../../sg-core";


export type IUseSaveHistoryPackageData = {
    saveHistoryPackage: (data: IObservationPackage) => Promise<TResult<string>>
};

/**
 * Hook that saves permit history package
 */
export const useSaveHistoryPackage = (): IUseSaveHistoryPackageData => {
    const { token, anonymousSession } = useAuthentication();

    const apiService = getSgApiService("");
    apiService.setToken(token || "");
    const observationService = getObservationService(apiService, Endpoint.havainnot, anonymousSession)

    const saveHistoryPackage: IUseSaveHistoryPackageData["saveHistoryPackage"] = async (data) => {
        try {
            const packageResult = await observationService.saveHistoryData(data);

            if (!packageResult.isSuccess) {
                throw packageResult.error;
            };

            return makeSuccess(packageResult.value.id);
        } catch (error) {
            console.info(error);
            return makeFailure(error as Error);
        };
    };


    return {
        saveHistoryPackage
    }
};

